import axios from "axios";
import { createMpcClient, notifyMpcWalletOnBackupSharesStored, notifyMpcWalletOnUserSharesStored, } from "../../utils/dwclient/dwclientutils";
import { generateMpcWalletUserShare, } from "../../utils/dwclient/portalhqutils";
import { baseUrl } from "../../utils/dwclient/dwcommonutils";
import { backup as portalHqUserShareBackup, } from "../../utils/dwclient/portalhqutils";
import { encryptAsciiStringToHexString } from "../../utils/dataEncryption";
import { createEmptyLogsAndVars, dwReportError, recordPotentialAxiosError, recordVariable, ReportingError, } from "../../utils/diagnostics/clientErrors";
import { storeClientId } from "../../utils/dwclient/localstorage/clientIdStorage";
import { storeClientSessionToken } from "../../utils/dwclient/localstorage/clientSessionTokenStorage";
import { getClientInfo } from "../../utils/dwclient/contracts/dwclientinfo";
import { jwtUploadFileReturnsJson } from "../../utils/dwclient/jwtcomm";
import { storeUserShares } from "../../utils/dwclient/localstorage/userShareStorage";
export async function createMpcWalletProcess(walletAddress, wallet) {
    //console.log("onboarding:create");
    const logsAndVars = createEmptyLogsAndVars("createMpcWallet:createMpcWallet");
    let clientId = "N/A";
    const myApiVersion = process.env.API_VERSION || "1.0";
    recordVariable(logsAndVars, "walletAddress", walletAddress);
    try {
        const createMpcClientResp = await createMpcClient(wallet.provider, walletAddress, myApiVersion);
        recordVariable(logsAndVars, "createMpcClient response", createMpcClientResp);
        clientId = createMpcClientResp.clientId;
        await storeClientId(wallet.provider, clientId);
        const clientSessionToken = createMpcClientResp.clientSessionToken;
        await storeClientSessionToken(wallet.provider, clientSessionToken);
        const jwt = createMpcClientResp.authToken;
        const userShares = await generateMpcWalletUserShare(clientSessionToken);
        await storeUserShares(wallet.provider, JSON.stringify(userShares));
        recordVariable(logsAndVars, "MPC wallet user shares", userShares);
        await saveSigningShares(clientSessionToken, userShares);
        // check if HTTP status 204 returned
        await notifyMpcWalletOnUserSharesStored(clientSessionToken, userShares.SECP256K1.id, userShares.ED25519.id);
        await backupUserShares(logsAndVars, wallet.provider, jwt, clientId, clientSessionToken, userShares);
        return {
            ...createMpcClientResp,
            userSharesString: JSON.stringify(userShares),
            ethWalletAddress: null,
            solanaWalletAddress: null,
        };
        // check if HTTP status 200 returned
    }
    catch (error) {
        recordPotentialAxiosError(logsAndVars, error);
        dwReportError(walletAddress, clientId, error, { logsAndVars });
        throw new ReportingError(error, logsAndVars);
    }
}
export async function backupUserShares(logsAndVars, provider, jwt, clientId, clientSessionToken, userShares) {
    const clientInfo = await getClientInfo(jwt, clientId);
    const myApiVersion = process.env.API_VERSION || "1.0";
    const backupShares = await portalHqUserShareBackup(clientSessionToken, userShares);
    recordVariable(logsAndVars, "MPC wallet backup shares", backupShares);
    await storeBackupShares(provider, clientId, clientInfo.metadata.namespaces.eip155?.address ?? "", clientInfo.metadata.namespaces.solana?.address ?? "", backupShares, jwt);
    // check if HTTP status 200 returned
    await notifyMpcWalletOnBackupSharesStored(clientSessionToken, backupShares.SECP256K1.id, backupShares.ED25519.id, myApiVersion);
}
// (OK?) MPC Wallet Management System / 5. Update MPC Wallet Signing Share Pairs Status
async function saveSigningShares(clientSessionToken, userShares) {
    const myApiVersion = process.env.API_VERSION || "1.0";
    const response = await axios.patch(`${baseUrl}/api/${myApiVersion}/mpc/signing-share-pairs`, {
        status: "STORED_CLIENT",
        signingSharePairIds: [userShares.SECP256K1.id, userShares.ED25519.id],
    }, {
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${clientSessionToken}`,
        },
    });
    return response.data;
}
// (OK?) MPC Wallet Management System / 7. Save User MPC Wallet Backup Info
async function storeBackupShares(provider, clientId, ethWalletAddress, solanaWalletAddress, backupShares, jwt) {
    const encClientId = await encryptAsciiStringToHexString(provider, clientId);
    const encEthWalletAddress = await encryptAsciiStringToHexString(provider, ethWalletAddress);
    const encSolanaWalletAddress = await encryptAsciiStringToHexString(provider, solanaWalletAddress);
    const encBackupShares = await encryptAsciiStringToHexString(provider, JSON.stringify(backupShares));
    const backupData = {
        encClientId,
        encEthWalletAddress,
        encSolanaWalletAddress,
        encBackupShares,
    };
    //console.log("storeBackupShares", backupData);
    // Convert the JSON to a Buffer
    const jsonData = JSON.stringify(backupData);
    const jsonAsFile = new File([jsonData], "backup_info.json", { type: "application/json" });
    const myApiVersion = process.env.API_VERSION || "1.0";
    const response = await jwtUploadFileReturnsJson("post", `/api/${myApiVersion}/mpc/backup`, jwt, jsonAsFile);
    return response.data;
}
